/* Checklist de documentos do lead + cadastro dos itens por fluxo
   (backend /lead-documentos). O arquivo sobe pelo upload genérico
   (/arquivos/upload) e aqui só se grava o caminho. */
import { apiFetch } from './apiClient';
import { uploadArquivoGenerico } from './arquivos';

const B = '/lead-documentos';

export const listarItensChecklist = () => apiFetch(`${B}/itens`);
export const criarItemChecklist = (fluxo, nome) => apiFetch(`${B}/itens`, { method: 'POST', body: JSON.stringify({ fluxo, nome }) });
export const atualizarItemChecklist = (id, dados) => apiFetch(`${B}/itens/${id}`, { method: 'PUT', body: JSON.stringify(dados) });
export const excluirItemChecklist = (id) => apiFetch(`${B}/itens/${id}`, { method: 'DELETE' });

export const buscarChecklistLead = (leadId) => apiFetch(`${B}/lead/${leadId}`);
export const atualizarDocumentoLead = (id, dados) => apiFetch(`${B}/${id}`, { method: 'PUT', body: JSON.stringify(dados) });

export async function anexarDocumentoLead(id, leadId, file) {
  const up = await uploadArquivoGenerico(file, `leads/${leadId}`);
  return atualizarDocumentoLead(id, { arquivo_path: up.url, arquivo_nome: up.nome });
}

export const STATUS_DOCUMENTO = [
  { id: 'pendente', label: 'Pendente' },
  { id: 'recebido', label: 'Recebido' },
  { id: 'nao_se_aplica', label: 'Não se aplica' },
];
